import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { CamposFormularioCadastroProduto } from './campos-formulario-cadastro-produto';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSave} from '@fortawesome/pro-duotone-svg-icons';

const FormularioCadastroProdutosModal = (props) => {
    const {onSalvar, title="Dados do Produto", visible, salvando, onCancel} = props;

    const [visivel, setVisivel] = useState(visible)

    useEffect(() => {
        setVisivel(visible);
    }, [visible])

    // const cancelHandleClick = (evt) => {
    //     setVisivel(false);
    //     onCancel && onCancel(evt);
    // }
    
    // const preenchePorcentagemAprxImpostos = async () => {
    //     const porcentagemAproximadaImpostos = await consultaPorcentagemAprxImpostos(dadosProduto, dadosProduto.ncm);
    //     const novosDadosProduto = Object.assign({}, dadosProduto, {porcentagemAproximadaImpostos});
    //     dispatch(atualizaProduto(novosDadosProduto));

    // }
    // useEffect(() => {
    //     if(produto.precisaPreencherImpostos()){
    //         preenchePorcentagemAprxImpostos();
    //     }
    // }, [dadosProduto]);


    return <Modal 
                title={title} 
                visible={visivel}
                onOk={onSalvar}
                confirmLoading={salvando}
                onCancel={onCancel}
                okText={"Salvar"}
                keyboard={false}
                maskClosable={false}
                width="calc(100% - 10px)"
                cancelText="Cancelar"
                style={{top: "10px"}}
                okButtonProps={{ 
                    
                    icon: <span><FontAwesomeIcon icon={faSave} />&nbsp;</span>
                }}
            >
            <CamposFormularioCadastroProduto {...props}></CamposFormularioCadastroProduto>
    </Modal>
    // return <Row>
    //     <Col span={24}>
    //         <CamposFormularioCadastroProduto {...props}></CamposFormularioCadastroProduto>
    //     </Col>

    //     <Divider></Divider>
        
    //     <Col span={24} style={{'textAlign': "right"}}>
    //         {saveButton}
    //     </Col>

    // </Row>
}

export {FormularioCadastroProdutosModal}